import { createSlice } from '@reduxjs/toolkit';
import { useNavigate } from 'react-router-dom';
import type { PayloadAction } from '@reduxjs/toolkit';
import { login } from '../services/authentication';
import { save, remove } from '../utils/storage';

import { ACCESS_TOKEN, AUTH_METHODS, REFRESH_TOKEN } from '../utils/constants';

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  registerUser: any;
}

const initialState: AuthState = {
  accessToken: localStorage.getItem(ACCESS_TOKEN) || null,
  refreshToken: localStorage.getItem(REFRESH_TOKEN) || null,
  registerUser: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authenticate: (state, action: PayloadAction<any>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    restoreToken: (state, action: PayloadAction<any>) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    registerUser: (state, action: PayloadAction<any>) => {
      state.registerUser = action.payload;
    },
    logout: (state) => {
      state.accessToken = null;
      state.refreshToken = null;
    },
  },
});

export const loginUser = (data: any, callback?: any) => async (dispatch: any) => {
  try {
    const result = await login(data);
    if (result?.kind === 'ok') {
      await save('@accessToken', result?.data?.data?.accessToken);
      await save('@refreshToken', result?.data?.data?.refreshToken);
      dispatch(authenticate(result?.data?.data));
      callback?.(result?.data?.data);
    } else {
    }
  } catch (err: any) {
    throw new Error(err);
    callback?.(null, err);
  }
};

export const logoutUserAction = () => async (dispatch: any) => {
  try {
    // await clear()
    await remove(ACCESS_TOKEN);
    await remove(REFRESH_TOKEN);
    dispatch(logout());
  } catch (err: any) {
    throw new Error(err);
  }
};

// Action creators are generated for each case reducer function
export const { authenticate, logout, restoreToken, registerUser } = authSlice.actions;

export default authSlice.reducer;
